import * as api from "../../api/index";
import * as endpoints from "../../api/endpoints";
import * as types from "../../api/../mutation-types";

const actions = {
  getDxGridSettings({ commit }, payload) {
    return api.fetch(endpoints.DXGRID_SETTINGS, payload, commit, (response) => {
      commit(types.SET_DXGRID_SETTINGS, response.data);
    });
  },
  setDxGridSettings({ commit }, payload) {
    return api.put(
      endpoints.DXGRID_SETTINGS,
      payload,
      commit,
      (response) => {
        commit(types.UPDATE_DXGRID_SETTINGS, response.data);
      }
    );
  },
};

export default actions;
